import React from 'react';
import { connect } from 'react-redux';
import UNVERIFIED_IMG from 'images/unverified.png';
import {
  doFetchProfile,
  doRefreshToken,
  doSentLinkVerificationEmail,
} from 'actions/authAction';
import { toast } from 'react-toastify';

interface IUnverifiedProps {
  fetchProfile: () => Promise<unknown>;
  refreshToken: () => Promise<unknown>;
  verifyEmail: () => Promise<unknown>;
}

const Unverified: React.FC<IUnverifiedProps> = (props) => {
  const { fetchProfile, refreshToken, verifyEmail } = props;

  const onClickSendEmail = () => {
    verifyEmail().then(() => {
      toast.success(
        'Please check your email to continue the verification process.',
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        },
      );
    });
  };

  const onClickVerified = () => {
    fetchProfile().then(() => {
      refreshToken();
    });
  };

  return (
    <div className="suspended-seller-container">
      <div className={'empty-container'}>
        <img src={UNVERIFIED_IMG} />
        <p className={'bottom-text'}>
          Attention, your email has not been verified. Please check your inbox /
          junk / spam for an email from no-reply@kickavenue.com and click the
          verification link in it.
        </p>
        <div className={'bottom-button'}>
          <div className={'button-send'} onClick={onClickSendEmail}>
            <p>Send email verification</p>
          </div>
          <div className={'button-verified'} onClick={onClickVerified}>
            <p>I'm verified!</p>
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    fetchProfile: () => dispatch(doFetchProfile()),
    refreshToken: () => dispatch(doRefreshToken()),
    verifyEmail: () => dispatch(doSentLinkVerificationEmail()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Unverified);
